export enum ConfirmationScreenTheme {
  Error = 'error',
  Primary = 'primary'
}
